export default function findDuplicates<T = string>(values: T[]): T[] {
  return values.filter((item, index) => values.indexOf(item) !== index);
}
